import { render, staticRenderFns } from "./SalesClosed.vue?vue&type=template&id=559dc504&"
import script from "./SalesClosed.vue?vue&type=script&lang=js&"
export * from "./SalesClosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports